import { Task, SubTask } from "@/api/task-api";
import TaskOutputOptions from "./ITaskOutputOptions";
import { duration } from "@/helpers/chart-helper";
import formatDateTime from "@/helpers/formatDateTime";
import { jsonToFormData } from "@/helpers/formData";

export default function TaskFormData(
  task: Task,
  options: TaskOutputOptions = { hasClosedDays: true, hasSubTasks: true }
): FormData {
  const d = new FormData();
  appendTask(d, task, options.hasClosedDays);
  if (options.hasSubTasks) {
    task.subTasks.forEach((t, i) => {
      appendSubTask(d, t, i);
    });
  }
  return d;
}

function appendTask(d: FormData, t: Task, hasClosedDays = true): void {
  d.append("task[id]", String(t.taskId || ""));
  d.append("task[taskGroupId]", String(t.taskGroupId || ""));
  d.append("task[name]", t.name);
  d.append("task[start]", formatDateTime(t.start));
  d.append("task[end]", formatDateTime(t.end));
  d.append("task[duration]", String(duration(t)));
  d.append("task[closedDays]", hasClosedDays ? closedDays(t.closedDays) : "");
}

function appendSubTask(d: FormData, t: SubTask, i: number): void {
  d.append(`subTask[${i}][id]`, String(t.taskId || ""));
  d.append(`subTask[${i}][name]`, t.name);
  d.append(`subTask[${i}][done]`, bool(t.done));
  d.append(`subTask[${i}][date]`, t.date || '');
  d.append(`subTask[${i}][time]`, t.time || '');
  jsonToFormData(t.users as object, d, `subTask[${i}][users]`);
}

function closedDays(days: number[]) {
  return days.join(",");
}

function bool(b: boolean) {
  return b ? "true" : "false";
}
